import { apiRequest } from './apiClient';

/**
 * İade faturalarını listele
 */
export const fetchIadeFaturalari = async ({ sayfa = 1, limit = 100, tab, arama } = {}) => {
  const queryParams = { sayfa, limit };
  if (tab) queryParams.tab = tab;
  if (arama) queryParams.arama = arama;

  const response = await apiRequest('/api/iade-faturalari', {
    method: 'GET',
    query: queryParams,
  });
  return response;
};

/**
 * İade fatura detayı getir
 */
export const fetchIadeFaturaDetay = async (id) => {
  const response = await apiRequest(`/api/iade-faturalari/${id}`, {
    method: 'GET',
  });
  return response;
};

/**
 * İade oluştur kataloğu (stok + cari bloke limitleri)
 */
export const fetchIadeOlusturKatalog = async () => {
  const response = await apiRequest('/api/iade-faturalari/olustur-katalog', {
    method: 'GET',
  });
  return response;
};

/**
 * İade parça talebi oluştur
 * @param {Array} parcalar - [{ icerikId, adet }]
 * @param {Object} options - { cariDuzeltme?: boolean }
 */
export const iadeFaturaOlustur = async (parcalar, options = {}) => {
  const body = { parcalar };
  if (options.cariDuzeltme) body.cariDuzeltme = true;
  const response = await apiRequest('/api/iade-faturalari', {
    method: 'POST',
    body,
  });
  return response;
};

/**
 * İade faturayı onayla (Admin)
 */
export const iadeFaturaOnayla = async (id) => {
  const response = await apiRequest(`/api/iade-faturalari/${id}/onayla`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

/**
 * İade faturayı iptal et (Admin — yalnızca OnayBekliyor)
 */
export const iadeFaturaIptal = async (id) => {
  const response = await apiRequest(`/api/iade-faturalari/${id}/iptal`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

/**
 * İade faturaya fatura numarası gir (Teknik Servis)
 */
export const iadeFaturaFaturaGir = async (id, faturaNumarasi) => {
  const response = await apiRequest(`/api/iade-faturalari/${id}/fatura`, {
    method: 'PATCH',
    body: { faturaNumarasi: String(faturaNumarasi || '').trim() },
  });
  return response;
};

/**
 * İade fatura ödemesini kaydet (Admin)
 */
export const iadeFaturaOdemeYap = async (id, { odemeYontemi, odemeNotu } = {}) => {
  const response = await apiRequest(`/api/iade-faturalari/${id}/odeme`, {
    method: 'PATCH',
    body: { odemeYontemi, odemeNotu: odemeNotu || '' },
  });
  return response;
};
